import { ErrorMessage, Field, Form, Formik } from 'formik'

const ShowInAppButton = ({showInApp = false, type, onUpdateSelectionShowInApp, pk}) =>  {
    const inAppIconClass = showInApp ? ' active' : ' inactive'
    const noAppImplementationClass = type === 'advertisement' || type === 'showtimes' ? true : false

    return noAppImplementationClass ? (
        <div className="field-checkbox button-selection-wrapper show-in-app-button-wrapper odd gap-35 not-in-app">
            <label className="show-in-app-label">
                <div id="show-in-app"/>
                <span className={"button icon button-show-in-app " + inAppIconClass}>
                    <span className="screen-reader-text">In der App anzeigen</span>    
                </span>
            </label> 
        </div>

    ) : (
        <Formik
            initialValues={{showInApp: showInApp}}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
                onUpdateSelectionShowInApp(pk, values.showInApp)
            }}>
            {({ values, errors, status, touched, isSubmitting, handleSubmit, handleChange }) => (
                <Form onChange={handleSubmit} className="field-checkbox button-selection-wrapper show-in-app-button-wrapper odd gap-35">
                    <label className="show-in-app-label">
                        <Field onChange={handleChange} type="checkbox" name="showInApp" id="show-in-app"/>
                        <span className={"button icon button-show-in-app " + inAppIconClass}>
                            <span className="screen-reader-text">In der App anzeigen</span>    
                        </span>
                    </label>
                    <ErrorMessage className="text-regular-color" name="showInApp" component="div" />  
                </Form>
            )}
        </Formik>
    )
}

export default ShowInAppButton